import UploadModelService from './service';

export * from './reqres';

export default UploadModelService;
